import { createResource, type Accessor } from 'solid-js';
import { useApi, isOk } from '../api';
import { useTranslation } from './useTranslation';

export const ZONE_FILTER_ALL = '';
export const ZONE_FILTER_OUTSIDE = 'outside';

export function useSellbotZones(botId: Accessor<string | null>) {
    const api = useApi();
    const { t } = useTranslation();

    const [config] = createResource(botId, async (id) => {
        const res = await api.sellbot.getConfig(id);
        return isOk(res.data) ? res.data.value : null;
    });

    const multiZone = () => config()?.zoneMode === 'Multi';
    const zones = () => config()?.zones ?? [];

    const zoneLabel = (zoneId?: string | null): string | null => {
        if (!multiZone() || !zoneId) return null;
        return zones().find(zone => zone.id === zoneId)?.name ?? t('SELLBOT_ZONE_REMOVED');
    };

    const matchesZoneFilter = (zoneId: string | null | undefined, zoneFilter: string): boolean => {
        if (!multiZone() || zoneFilter === ZONE_FILTER_ALL) return true;
        if (zoneFilter === ZONE_FILTER_OUTSIDE) return !zoneId;
        return zoneId === zoneFilter;
    };

    return { multiZone, zones, zoneLabel, matchesZoneFilter };
}
